import { Stack } from '@mui/material'

import { MINIMUM_PASSWORD_LENGTH } from '../helpers/constants'
import { hasMixedCase, hasMinimumCharacters, hasNumber, hasSpecialChar, hasNoSpaces } from '../helpers/checks'

import { RequirementsItem } from './RequirementsItem'

interface PasswordRequirementsListProps {
  password: string
}

export function PasswordRequirementsList({ password }: PasswordRequirementsListProps) {
  const requirements = [
    {
      label: `Deve conter no mínimo ${MINIMUM_PASSWORD_LENGTH} caracteres`,
      met: hasMinimumCharacters(password),
    },
    {
      label: 'Deve conter letras maiúsculas e minúsculas',
      met: hasMixedCase(password),
    },
    {
      label: 'Deve conter ao menos um número',
      met: hasNumber(password),
    },
    {
      label: 'Deve conter caracteres especiais',
      met: hasSpecialChar(password),
    },
    {
      label: 'Não deve conter espaços em branco',
      met: hasNoSpaces(password),
    },
  ]

  return (
    <Stack>
      {requirements.map((requirement) => (
        <RequirementsItem key={requirement.label} {...requirement} />
      ))}
    </Stack>
  )
}
